import { render, staticRenderFns } from "./ActivationBriefAssetsView.vue?vue&type=template&id=ac10562a&scoped=true&"
import script from "./ActivationBriefAssetsView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefAssetsView.vue?vue&type=script&lang=js&"
import style0 from "./ActivationBriefAssetsView.vue?vue&type=style&index=0&id=ac10562a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac10562a",
  null
  
)

export default component.exports